<div class="row" style="min-height: 200px;">
  <div class="col">
    <div class="row">
      <div class="col">
        <div class="inline-block deviceOptionsHeader">
          <sb-icon class="red" icon="attention"></sb-icon>&nbsp;
        </div>
        <div class="red inline-block deviceOptionsHeader">
          &nbsp;{{ 'lang.device.calibrationImage' | translate }}
        </div>
      </div>
    </div>
    <div class="row tw-mt-4">
      <div class="col-12">
        <div class="tablewrap">
          <div class="d-flex flex-row bb">
            <div
              class="mt-3 row-body align-self-center d-flex flex-column flex-md-row justify-content-between min-width-zero align-items-md-center header">
              <p class="w-100">{{ 'lang.globals.deviceId' | translate }}</p>
              <p class="w-100 tr mr-2"><b>{{ device.id }}</b></p>
            </div>
          </div>
          <div class="d-flex flex-row bb">
            <div
              class="mt-3 row-body align-self-center d-flex flex-column flex-md-row justify-content-between min-width-zero align-items-md-center header">
              <p class="w-100">{{ 'lang.device.calibrationImageMessage' | translate }}</p>
            </div>
          </div>
          <div class="d-flex flex-row bb">
            <div
              class="my-3 row-body align-self-center d-flex flex-column flex-md-row justify-content-between min-width-zero align-items-md-center header">
              <div>
                {{ 'lang.device.durationCalibrationImage' | translate }}
              </div>
              <div class="tw-flex tw-items-center tw-justify-center">
                <input type="number" class="tw-w-20 tr" [(ngModel)]="displayTime" placeholder="-" />&nbsp;{{'lang.globals.inSeconds'|translate}}
              </div>
            </div>
          </div>
          <div class="d-flex flex-row bb">
            <div
              class="my-3 row-body align-self-center d-flex flex-column flex-md-row justify-content-between min-width-zero align-items-md-center header">
              <button class="btn btn-danger" (click)="hideImage()">
                <sb-icon icon="eyeNone"></sb-icon>&nbsp;{{ 'lang.device.hideCalibrationImage' | translate }}
              </button>
              <button class="btn btn-success" (click)="showImage()">
                <sb-icon icon="eye"></sb-icon>&nbsp;{{ 'lang.device.showCalibrationImage' | translate }}
              </button>


            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
